import React, { useEffect, useContext, useState } from 'react';
import { 
  Dialog, 
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DocumentViewer from './DocumentViewer';
import AuthGuard from '../auth/AuthGuard';
import { AuthContext } from '../../context/AuthContext';
import { supabase } from '../../supabaseClient';

const DocumentViewerModal = ({ open, onClose, document }) => {
  const { user } = useContext(AuthContext);
  const [alertDialog, setAlertDialog] = useState({ open: false, message: '' });

  // Lock document when opened
  useEffect(() => {
    if (open && document) {
      const lockDocument = async () => {
        const { error } = await supabase
          .from('documents')
          .update({ locked_by: user.id })
          .eq('id', document.id);

        if (error) {
          console.error('Lock error:', error);
          onClose();
        }
      };

      lockDocument();
    }

    // Unlock when closed or unmounted
    return () => {
      if (document) {
        supabase
          .from('documents')
          .update({ locked_by: null })
          .eq('id', document.id)
          .eq('locked_by', user.id)
          .then(({ error }) => {
            if (error) console.error('Unlock error:', error);
          });
      }
    };
  }, [open, document, user.id]);

  useEffect(() => {
    if (!document) return;
  
    const channel = supabase.channel('document_changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'documents',
          filter: `id=eq.${document.id}`
        },
        (payload) => {
          if (payload.new && payload.new.locked_by !== user.id) {
            onClose();
            if (!payload.new.locked_by) {
              setAlertDialog({
                open: true,
                message: 'Je bent ontkoppeld van het document!'
              });
            } else {
              setAlertDialog({
                open: true,
                message: 'Je toegang tot dit document is ingetrokken'
              });
            }
          }
        }
      )
      .subscribe();
  
    return () => {
      supabase.removeChannel(channel);
    };
  }, [document, onClose, user.id]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            height: '90vh',
            width: '95vw',
            maxWidth: 'none',
            m: 2,
            position: 'relative'
          }
        }}
      >
        <AuthGuard>
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.500',
              zIndex: 1
            }}
          >
            <CloseIcon />
          </IconButton>
          
          {document && <DocumentViewer document={document} />}
        </AuthGuard>
      </Dialog>

      <Dialog
        open={alertDialog.open}
        onClose={() => setAlertDialog({ open: false, message: '' })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Document toegang
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alertDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setAlertDialog({ open: false, message: '' })} 
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DocumentViewerModal;
